import { Button } from '../../common/components/button'
import { DynamicButtonGroup } from '../../common/components/dynamic-button-group'
import { NotificationManager } from '../../common/components/Notifications'

import { usePageEditorContext } from '../contexts/page-editor.context'
import { blockLabelsCopyService } from './block-labels-copy.service'
import { blockEditService } from './block-edit.service'

export const BlockEditButtonGroup = function ({ isInEditMode, onModeToggle, canPreview = false }) {
  const pageEditorContext = usePageEditorContext() || {}
  const currentEdit = pageEditorContext.currentEdit || {}
  const block = currentEdit.block || {}

  function allowEditModeToggle () {
    // Always allow switching from Preview mode to Edit mode
    if (!isInEditMode) {
      return true
    }
    return canPreview && !blockEditService.hasParentBlock(block)
  }

  function toggleEditMode () {
    // If required subgroup selections are not made - prevent preview switch
    if (isInEditMode && currentEdit.validate && !currentEdit.validate()) {
      return
    }
    onModeToggle(!isInEditMode)
  }

  function handleCopyLabels () {
    blockLabelsCopyService.copy(block)
    NotificationManager.create({ type: 'success', timeOut: 10000, message: 'Success! Please paste your labels to another block.' })
  }

  function handlePasteLabels () {
    blockLabelsCopyService.pasteTo(block)
    pageEditorContext.registerUnsavedChanges()
    currentEdit.block = { ...currentEdit.block }
    pageEditorContext.updateCurrentEdit(currentEdit)
    NotificationManager.create({ type: 'success', timeOut: 10000, message: 'Success! Your labels have been applied.' })
  }

  return (
    <DynamicButtonGroup variant="secondary">
      {[
        <Button key="preview" onClick={toggleEditMode} disabled={!allowEditModeToggle()} data-qa="block-edit-mode-toggle">
          {isInEditMode ? 'Preview' : 'Edit'}
        </Button>,
        <Button key="copy-labels" onClick={handleCopyLabels}>Copy Labels</Button>,
        <Button key="paste-labels" onClick={handlePasteLabels}>Paste Labels</Button>
      ].filter(({ key }) => {
        switch (key) {
          case 'paste-labels':
            return blockLabelsCopyService.hasCopiedBlock()
          default:
            return true
        }
      })}
    </DynamicButtonGroup>
  )
}
